import { Controller, useFormContext } from 'react-hook-form';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Partner_CreateUpdatePartnerInput } from 'queries';

import FormPhoneField from 'common/form-phone-field';
import FormTextField from 'common/form-text-field';

const useStyles = makeStyles(() => ({
  formContainer: {
    display: 'flex',
  },
  buttonContainer: {
    float: 'right',
    marginBottom: '10vh',
    width: '45vw',
  },
  saveButton: {
    backgroundColor: '#F5DE76',
    marginRight: '2.5vw',
    float: 'right',
    color: '#434E59',
  },
  cancelButton: {
    color: '#ffffff',
    backgroundColor: '#8DA8B2',
    float: 'right',
  },
  paddingLeft: {
    paddingLeft: '20px',
  },
}));

const PartnerForm = () => {
  const classes = useStyles();

  const {
    control,
    formState: { errors },
  } = useFormContext<Partner_CreateUpdatePartnerInput>();

  return (
    <>
      <Grid container>
        <Grid item xs={12} md={6}>
          <Controller
            name="name"
            control={control}
            render={({ field: { ref, ...field } }) => (
              <FormTextField
                {...field}
                inputRef={ref}
                errorMessage={errors.name?.message}
                label="Full Name"
              />
            )}
          />
        </Grid>
        <Grid item xs={12} md={6} className={classes.paddingLeft}>
          <Controller
            name="title"
            control={control}
            render={({ field: { ref, ...field } }) => (
              <FormTextField
                {...field}
                inputRef={ref}
                errorMessage={errors.title?.message}
                label="Title"
              />
            )}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Controller
            name="email"
            control={control}
            render={({ field: { ref, ...field } }) => (
              <FormTextField
                {...field}
                inputRef={ref}
                errorMessage={errors.email?.message}
                label="Email"
              />
            )}
          />
        </Grid>
        <Grid item xs={12} md={6} className={classes.paddingLeft}>
          <Controller
            name="phone"
            control={control}
            render={({ field: { name, onBlur, onChange, value } }) => (
              <FormPhoneField
                name={name}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                errorMessage={errors.phone?.message}
                label="Phone Number"
              />
            )}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Controller
            name="website"
            control={control}
            render={({ field: { ref, ...field } }) => (
              <FormTextField
                {...field}
                inputRef={ref}
                errorMessage={errors.website?.message}
                label="Website"
              />
            )}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default PartnerForm;
